import styled from "styled-components";
import MetricsLineChart from "./MetricsLineChart";
import { formatMetricValue, camelCaseToTitleCase } from "./formatters";
import { getLatestValue, transformToChartData, TimeseriesPoint } from "./helpers";

const MetricHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
`;

const MetricName = styled.div`
    font-size: 14px;
    font-weight: 600;
    color: ${(props) => props.theme.secondary};
`;

const MetricLatestValue = styled.div`
    font-size: 14px;
    color: #787878;
`;

interface SingleMetricChartProps {
    name: string;
    data: TimeseriesPoint[];
    height?: number;
    categoryHint?: string;
}

export default function SingleMetricChart({ name, data, height = 300, categoryHint }: SingleMetricChartProps) {
    const latestValue = getLatestValue(data);
    const chartData = transformToChartData(data);
    const displayName = camelCaseToTitleCase(name);
    const hint = categoryHint || name;

    return (
        <>
            <MetricHeader>
                <MetricName>{displayName}</MetricName>
                <MetricLatestValue>
                    Latest: {latestValue !== null ? formatMetricValue(latestValue, name, hint) : "N/A"}
                </MetricLatestValue>
            </MetricHeader>
            <MetricsLineChart
                data={chartData}
                lines={[{ dataKey: "value", name: displayName }]}
                height={height}
                categoryHint={hint}
            />
        </>
    );
}
